import React from "react";

const CustomerManagementList = React.lazy(() => import('src/pages/customer_management/CustomerManagementList'));
const AddCustomerManagement = React.lazy(() => import('src/pages/customer_management/AddCustomerManagement'));
const EditCustomerManagement = React.lazy(() => import('src/pages/customer_management/EditCustomerManagement'));
const CustomerPurchases = React.lazy(() => import('src/pages/customer_management/CustomerPurchases'));

const routes = [
    { path: '/dashboard/customer-management-list/add', name: 'Add', element: AddCustomerManagement },
    { path: '/dashboard/customer-management-list/edit', name: 'Edit', element: EditCustomerManagement },
    { path: '/dashboard/customer-management-list/:customer_id/purchases', name: 'Purchases', element: CustomerPurchases },
    { path: '/dashboard/customer-management-list', name: 'Customer Management', element: CustomerManagementList },
];

export default routes;